/* eslint-disable react-refresh/only-export-components */
import * as React from 'react';
import {
  Toaster,
  useToastController,
  Toast,
  ToastTitle,
  ToastBody,
} from '@fluentui/react-components';

type ToastOptions = {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
};

type ToastContextType = {
  toast: (options: ToastOptions) => void;
};

const ToastContext = React.createContext<ToastContextType | null>(null);

export const ToastProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { dispatchToast } = useToastController();

  const api = React.useMemo<ToastContextType>(
    () => ({
      toast: ({ title, description, variant }) =>
        dispatchToast(
          <Toast>
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastBody>{description}</ToastBody>}
          </Toast>,
          { intent: variant === 'destructive' ? 'error' : 'info' }
        ),
    }),
    [dispatchToast]
  );

  return (
    <ToastContext.Provider value={api}>
      {children}
      <Toaster />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = React.useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
};
